
import React from 'react';

import ReactDOM from 'react-dom';
 

import KeeVue from '../base/KeeVue.js'
 
export default class FsCssManager extends KeeVue {
	constructor(props) {
		super(props);

		this.state = {
			isShow: false,
			randId: this.getRandString(),

		}

	}

	componentWillMount() {
		var that = this;
		this.registComponent();

	}
 
	render() {
	 
		var style = JSON.parse(JSON.stringify(this.props.component.style));
		// 强制col的display为block
		style.display="block";
		return (

			<div  >
				 css 管理器 
			</div>

		);
	}
}
